import { render, staticRenderFns } from "./LessonsAttach.vue?vue&type=template&id=7ec23897"
import script from "./LessonsAttach.vue?vue&type=script&lang=js"
export * from "./LessonsAttach.vue?vue&type=script&lang=js"
import style0 from "./LessonsAttach.vue?vue&type=style&index=0&id=7ec23897&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports